import { useState, useEffect } from 'react';

const FotoVideographieServices = () => {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const timer = setTimeout(() => setIsVisible(true), 200);
    return () => clearTimeout(timer);
  }, []);

  const services = [
    {
      icon: 'ri-camera-3-line',
      title: 'Produktfotografie',
      description: 'Hochwertige Produktaufnahmen, die Ihre Produkte perfekt in Szene setzen und Kunden überzeugen.',
      features: ['Studio & On-Location', '360° Produktansichten', 'Lifestyle-Aufnahmen', 'E-Commerce optimiert']
    },
    {
      icon: 'ri-building-line',
      title: 'Unternehmensfotografie',
      description: 'Professionelle Unternehmensfotos für Ihre Website, Social Media und Marketingmaterialien.',
      features: ['Team-Portraits', 'Büro & Räumlichkeiten', 'Event-Dokumentation', 'Corporate Identity']
    },
    {
      icon: 'ri-video-line',
      title: 'Videoproduktion',
      description: 'Emotionale Videos, die Ihre Geschichte erzählen und Ihre Zielgruppe begeistern.',
      features: ['Imagefilme', 'Produktvideos', 'Social Media Content', 'Werbefilme']
    },
    {
      icon: 'ri-flight-takeoff-line',
      title: 'Drohnenaufnahmen',
      description: 'Beeindruckende Luftaufnahmen für eine einzigartige Perspektive auf Ihr Projekt.',
      features: ['4K Luftaufnahmen', 'Immobilien-Präsentation', 'Event-Coverage', 'Landschaftsaufnahmen']
    },

    {
      icon: 'ri-edit-2-line',
      title: 'Post-Production',
      description: 'Professionelle Nachbearbeitung für perfekte Ergebnisse in Bild und Video.',
      features: ['Farbkorrektur', 'Retusche', 'Video-Schnitt', 'Motion Graphics']
    }
  ];

  return (
    <section id="services" className="py-32 bg-black relative overflow-hidden">
      {/* Subtle Background Pattern */}
      <div className="absolute inset-0 opacity-5">
        <div className="absolute inset-0" style={{
          backgroundImage: 'radial-gradient(circle at 2px 2px, white 1px, transparent 0)',
          backgroundSize: '40px 40px'
        }}></div>
      </div>

      <div className="container mx-auto px-6 relative z-10">
        <div className={`text-center mb-20 transition-all duration-1000 ${
          isVisible ? 'translate-y-0 opacity-100' : 'translate-y-10 opacity-0'
        }`}>
          <span className="text-[#d1bc8a] text-sm uppercase tracking-[0.3em] font-light mb-6 block">
            Unsere Leistungen
          </span>
          <h2 className="text-5xl md:text-7xl font-bold text-white mb-6">
            Foto & Video
            <br />
            <span className="text-[#d1bc8a]">Services</span>
          </h2>
          <p className="text-xl text-white/70 max-w-3xl mx-auto font-light">
            Von der Konzeption bis zur finalen Auslieferung – wir bieten professionelle Foto- und Videoproduktion aus einer Hand
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8 max-w-7xl mx-auto">
          {services.map((service, index) => (
            <div
              key={index}
              className={`group bg-zinc-900 rounded-2xl p-8 hover:bg-zinc-800 transition-all duration-500 border border-zinc-800 hover:border-[#d1bc8a]/30 ${
                isVisible ? 'translate-y-0 opacity-100' : 'translate-y-10 opacity-0'
              }`}
              style={{ transitionDelay: `${index * 100}ms` }}
            >
              <div className="w-16 h-16 bg-[#d1bc8a]/10 rounded-xl flex items-center justify-center mb-6 group-hover:bg-[#d1bc8a]/20 transition-colors duration-300">
                <i className={`${service.icon} text-3xl text-[#d1bc8a]`}></i>
              </div>
              
              <h3 className="text-2xl font-bold text-white mb-4 group-hover:text-[#d1bc8a] transition-colors duration-300">
                {service.title}
              </h3>
              
              <p className="text-white/60 mb-6 leading-relaxed">
                {service.description}
              </p>

              <ul className="space-y-3">
                {service.features.map((feature, idx) => (
                  <li key={idx} className="flex items-center text-white/50 text-sm">
                    <i className="ri-check-line text-[#d1bc8a] mr-3"></i>
                    {feature}
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default FotoVideographieServices;